var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInterfaceEssentialAnchor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4143 3.9191C12.1953 4.70015 12.1953 5.96647 11.4143 6.74752C10.6332 7.52857 9.3669 7.52857 8.58585 6.74752C7.8048 5.96648 7.8048 4.70015 8.58585 3.9191C9.3669 3.13805 10.6332 3.13805 11.4143 3.9191",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 16.6666V7.33331",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 10H3.33331C3.33331 13.6817 6.31831 16.6667 9.99998 16.6667C13.6816 16.6667 16.6666 13.6817 16.6666 10H14.6666",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInterfaceEssentialAnchor);
export default ForwardRef;